import { render, staticRenderFns } from "./LearningPathCreate.vue?vue&type=template&id=572a35fd&scoped=true&"
import script from "./LearningPathCreate.vue?vue&type=script&lang=ts&"
export * from "./LearningPathCreate.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPathCreate.vue?vue&type=style&index=0&id=572a35fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a35fd",
  null
  
)

export default component.exports